import _classCallCheck from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import logger from '../logger';
/**
 * The basic store skeleton. It must be implemented by all store classes.
 * @author BPo
 * @author SKu
 */

export var BaseStore =
/*#__PURE__*/
function () {
  function BaseStore(rootStore) {
    _classCallCheck(this, BaseStore);

    this.rootStore = rootStore;
  }
  /**
   * Handles error catch
   * @param error {AxiosError}
   * @param functionName where error had been caught
   * @returns Rejected promise
   */


  _createClass(BaseStore, [{
    key: "handleCatchError",
    value: function handleCatchError(error, functionName) {
      // fixme warn followed by error?
      logger.warn("function - ".concat(functionName));
      logger.error(error);
      return Promise.reject(error);
    }
  }]);

  return BaseStore;
}();